import { useTranslation } from 'react-i18next';
import DeckStack from './DeckStack';
import { ShuffleIcon, DrawIcon } from './DeckIcons';
import { SHUFFLE_MS } from '../flow/useReadingFlow';
import './DeckSection.css';

// `locked` once the cards have been drawn: the deck has gone down to the fan
// (CardFanSelector carries it there from `deckRef`), leaving its place marked
// and its buttons greyed
function DeckSection({ isShuffling, hasShuffled, onShuffle, onDraw, numCards, deckRef, locked = false }) {
  const { t } = useTranslation();

  return (
    <div className="draw-section">
      <div
        className={`deck-container ${isShuffling ? 'shuffling' : ''} ${locked ? 'is-drawn' : ''}`}
        style={{ '--shuffle-dur': `${SHUFFLE_MS}ms` }}
      >
        <DeckStack ref={deckRef} />
      </div>
      <div className="draw-buttons">
        <button
          className="deck-btn"
          onClick={onShuffle}
          disabled={isShuffling || locked}
        >
          <ShuffleIcon />
          <span className="deck-btn__label">
            {isShuffling
              ? t('deck.shuffling')
              : hasShuffled ? t('deck.shuffleAgain') : t('deck.shuffle')}
          </span>
        </button>
        {/* Shuffling again is the same step over: the deck is reordered and
            can be drawn from once it has settled */}
        {hasShuffled && (
          <button
            className="deck-btn deck-btn--primary"
            onClick={onDraw}
            disabled={isShuffling || locked}
          >
            <DrawIcon />
            <span className="deck-btn__label">
              {t('deck.drawCardTitle', { count: numCards })}
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default DeckSection;
